/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2018, Zumper
 * @description  Extract the cityPath, hoodPath and statePath from a locationPath
 */

// NOTE: compare to patterns.locationPath. Here we can do it with city-state/hood but in
// routeDefinitions we need to account for filtersPath. The regex below uses capture groups while
// the regex in routeDefinitions does not.
const cityStateHoodPath = /[/]?(?:(\w[-\w.']*)-)?([a-z]{2})(?:[/]([\w'][-\w.']+))?$/i

const matchLocationPath = (locationPath?: string) => {
  if (!locationPath) {
    return {}
  }
  const match = locationPath.match(cityStateHoodPath)
  if (!match) {
    return {}
  }
  const [, cityPath, statePath, hoodPath] = match
  // NOTE: currentSearchRoutes have three separate routes for city-state, hood and state-only.
  // A hoodPath is only valid if there's a cityPath. It is unlikely that a hood-only or state-hood
  // path that it to this function. Here we protect against that oddity for parity with how
  // currentSearchRoutes is configured.
  return {
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    cityPath: cityPath && cityPath.toLowerCase(),
    hoodPath: cityPath && hoodPath && hoodPath.toLowerCase(),
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    statePath: statePath && statePath.toLowerCase(),
  }
}

export default matchLocationPath
